// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.70927acd',
  revision: '70927acd',
  branch: 'develop',
  date: 'Thu, 26 Mar 2026 17:04:05 GMT'
};